module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// F:/Solutions/7572bo/master/~/core-js/modules/_fails.js
// module id = 48
// module chunks = 1